// extracted by mini-css-extract-plugin
module.exports = {"contextTable":"style_contextTable__31j3O","TableHeading":"style_TableHeading__115pC","TableUL":"style_TableUL__3OiuP","TableLI":"style_TableLI__16nlj"};